// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  min-height: 80vh;
  overflow: auto;
}
.home::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.home::-webkit-scrollbar-thumb {
  background: #3b00f8;
}
.home::-webkit-scrollbar-track {
  background: #9d80fc;
}
@media (max-width: 600px) {
  .home::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .home::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .home::-webkit-scrollbar-track {
    background: white;
  }
}
.home .home_overview {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  gap: 0px;
}
@media (max-width: 1000px) {
  .home .home_overview {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 0px;
  }
}
.home .home_overview .overview_column {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap;
  margin: 2vh auto;
}
.home .home_overview .overview_column .overview_section {
  background-color: #151042;
  width: 48vw;
  border-radius: 8px;
}
.home .home_overview .overview_column .overview_section h2,
.home .home_overview .overview_column .overview_section h4 {
  color: #fff;
}
.home .home_overview .overview_column .overview_section h4 {
  font-size: 2rem;
  color: #ffe169;
}
@media (max-width: 1000px) {
  .home .home_overview .overview_column .overview_section {
    width: 95vw;
  }
}
.home .home_overview .overview_column .overview_section .status_table,
.home .home_overview .overview_column .overview_section .overview_table,
.home .home_overview .overview_column .overview_section .failed_table {
  background-color: white;
  width: 95%;
}
@media (max-width: 1000px) {
  .home .home_overview .overview_column .overview_section .overview_table td:nth-of-type(1):before {
    content: "Face Name";
  }
  .home .home_overview .overview_column .overview_section .overview_table td:nth-of-type(2):before {
    content: "End Location";
  }
  .home .home_overview .overview_column .overview_section .overview_table td:nth-of-type(3):before {
    content: "Daily Count";
  }
}
@media (max-width: 1000px) {
  .home .home_overview .overview_column .overview_section .status_table td:nth-of-type(1):before {
    content: "Status";
  }
  .home .home_overview .overview_column .overview_section .status_table td:nth-of-type(2):before {
    content: "Total";
  }
}
@media (max-width: 1000px) {
  .home .home_overview .overview_column .overview_section .failed_table td:nth-of-type(1):before {
    content: "Event Id";
  }
  .home .home_overview .overview_column .overview_section .failed_table td:nth-of-type(2):before {
    content: "End Location";
  }
  .home .home_overview .overview_column .overview_section .failed_table td:nth-of-type(3):before {
    content: "Created";
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/home.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,gBCgBU;EDfV,cAAA;AADJ;AC4DI;EACI,YD3DgB;EC4DhB,aD5DgB;AAExB;AC6DI;EACI,mBAxDO;ADHf;AC8DI;EACI,mBAbe;AD/CvB;AAPI;ECyDA;IACI,UDzDoB;IC0DpB,WD1DoB;EAW1B;ECkDE;IACI,gBA9DA;EDcN;ECmDE;IACI,iBAbe;EDpCrB;AACF;AAhBI;ECoBA,aAAA;EACA,uBDpBkB;ECqBlB,uBDrB0B;ECsB1B,mBDtBsC;ECuBtC,QDvB2C;AAsB/C;AArBQ;EAFJ;ICoBA,aAAA;IACA,uBDlBsB;ICmBtB,uBDnB8B;ICoB9B,sBDpB0C;ICqB1C,QDrBkD;EA4BpD;AACF;AA3BQ;ECeJ,aAAA;EACA,uBDfsB;ECgBtB,uBDhB8B;ECiB9B,sBDjB0C;ECkB1C,SDlBkD;EAC1C,eAAA;EACA,gBAAA;AAiCZ;AAhCY;EACI,yBCPG;EDQH,WAAA;EACA,kBAAA;AAkChB;AAjCgB;;EAEI,WCjBZ;ADoDR;AAjCgB;EACI,eAAA;EACA,cCbH;ADgDjB;AAhCgB;EAbJ;IAcQ,WAAA;EAmClB;AACF;AAjCgB;;;EAGI,uBAAA;EACA,UAAA;AAmCpB;AA/BoB;EACI;IACI,oBAAA;EAiC1B;EA/BsB;IACI,uBAAA;EAiC1B;EA/BsB;IACI,sBAAA;EAiC1B;AACF;AA5BoB;EACI;IACI,iBAAA;EA8B1B;EA5BsB;IACI,gBAAA;EA8B1B;AACF;AAzBoB;EACI;IACI,mBAAA;EA2B1B;EAzBsB;IACI,uBAAA;EA2B1B;EAzBsB;IACI,kBAAA;EA2B1B;AACF","sourcesContent":["@import \"../../variables.scss\";\n\n.home {\n    min-height: $main-height;\n    overflow: auto;\n    @include scrollbars(0.7em, $nitrocamBlue);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n    .home_overview {\n        @include flex(center, flex-start, row, 0px);\n        @media (max-width: $tablet) {\n            @include flex(center, flex-start, column, 0px);\n        }\n        .overview_column {\n            @include flex(center, flex-start, column, 10px);\n            flex-wrap: wrap;\n            margin: 2vh auto;\n            .overview_section {\n                background-color: $nitrocamDarkBlue;\n                width: 48vw;\n                border-radius: 8px;\n                h2,\n                h4 {\n                    color: $white;\n                }\n                h4 {\n                    font-size: 2rem;\n                    color: $nitrocamYellow;\n                }\n\n                @media (max-width: $tablet) {\n                    width: 95vw;\n                }\n\n                .status_table,\n                .overview_table,\n                .failed_table {\n                    background-color: white;\n                    width: 95%;\n                }\n\n                .overview_table {\n                    @media (max-width: $tablet) {\n                        td:nth-of-type(1):before {\n                            content: \"Face Name\";\n                        }\n                        td:nth-of-type(2):before {\n                            content: \"End Location\";\n                        }\n                        td:nth-of-type(3):before {\n                            content: \"Daily Count\";\n                        }\n                    }\n                }\n\n                .status_table {\n                    @media (max-width: $tablet) {\n                        td:nth-of-type(1):before {\n                            content: \"Status\";\n                        }\n                        td:nth-of-type(2):before {\n                            content: \"Total\";\n                        }\n                    }\n                }\n\n                .failed_table {\n                    @media (max-width: $tablet) {\n                        td:nth-of-type(1):before {\n                            content: \"Event Id\";\n                        }\n                        td:nth-of-type(2):before {\n                            content: \"End Location\";\n                        }\n                        td:nth-of-type(3):before {\n                            content: \"Created\";\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
